module.exports = __webpack_public_path__ + "img/hopital.814dcdeb.png";